import { Check, Trash } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'reactstrap/lib/Button'


import { Input } from '@components/form/Input'
import { MultiSelect } from '@components/form/MultiSelect'
import { Textarea } from '@components/form/Textarea'
import { formatFilters } from './FormatFilters'
import { useEffect } from 'react'
import { startLoadingTable } from '../../../../redux/actions/list'

import { handleChangeController, handleCleanForm } from '../../../../redux/actions/form'
import { SelectorComponent } from '../../../../utility/helpers/Components/selectorComponent'


export const AdvancedFilter = ({ title, filters, endPoint }) => {

    const dispatch = useDispatch()
    const { form } = useSelector(state => state)
    const rFilter = filters?.extraUrl ? filters['filters'] : filters
    const method = filters?.method ? filters['method'] : 'GET'
    useEffect(() => {
        rFilter.map(filter => {
            if (filter.value) dispatch(handleChangeController(filter.name, filter.value))
        })
    }, [])
    const filter = endPoint === 'surgery' ? 'filter' : 's'


    return (
        <div className="card">
            <div className="card-header">
                <h1 className="card-title pb-0 px-2 col-12 col-md-5 col-lg-7 col-xl-9 mb-1">Filtro Avanzado - {title}</h1>
                <div className='row col-12 col-md-7 col-lg-5 col-xl-3'>
                    <Button className='mr-1 col-5' style={{ maxWidth: 'fit-content' }} onClick={() => {
                        dispatch(handleCleanForm())
                        dispatch(startLoadingTable(endPoint))
                    }}>
                        <Trash size={15} />
                        <span className='align-middle ml-50'>Limpiar Filtros</span>
                    </Button>
                    <Button color='primary col-5' style={{ maxWidth: 'fit-content' }} onClick={() => {
                        dispatch(startLoadingTable(endPoint, { extraUrl: filters.extraUrl, ...(filters.extraUrl) ? form : formatFilters(form, filter) }, method))
                    }}>
                        <Check size={15} />
                        <span className='align-middle ml-50'>Aplicar Filtros</span>
                    </Button>
                </div>
            </div>
            <div className=" card-body row pb-3 px-3">
                {rFilter.map((e, i) => {
                    if (e.col) {
                        const clase = `col-${e.col[0]} col-xs-${e.col[0]} col-md-${e.col[1]} col-lg-${e.col[2]}`
                        const Component = ((e.endPoint || e.customOptions) && e.multi) ? MultiSelect : SelectorComponent(e)
                        return (
                            <div key={i} className={clase}>
                                <Component {...e} />
                            </div>
                        )
                    }
                })}
            </div>
        </div>
    )
}